import React from 'react';
import {Helmet} from 'react-helmet';

import {title} from 'lib/head';

import AccountTypeStep from './AccountTypeStep';
import SignUpFormStep from './SignUpFormStep';
import SignUpCarousel, {SignUpCarouselMobile} from './SignUpCarousel';
import SignUpStudentPanel from './SignUpStudentPanel';

interface SignUpPageProps {
  location?: {
    query?: {
      accountType?: string;
    };
  };
}

export default function SignUpPage({location}: SignUpPageProps) {
  const accountType = location?.query?.accountType;
  const validAccountType =
    accountType === 'educator' || accountType === 'student' ? accountType : null;

  return (
    <>
      <Helmet>{title('Sign Up | Albert')}</Helmet>
      <div className='-mt-[60px] flex min-h-[calc(100vh-60px)] flex-col overflow-x-clip m:flex-row'>
        {/* Form content */}
        <div className='flex w-full flex-col items-center justify-center p-x4 m:w-1/2'>
          {validAccountType ? (
            <SignUpFormStep accountType={validAccountType} />
          ) : (
            <AccountTypeStep />
          )}
        </div>

        {/* Mobile carousel */}
        <div className='m:hidden'>
          <SignUpCarouselMobile />
        </div>

        {/* Desktop right panel */}
        <div className='hidden m:block m:w-1/2'>
          {validAccountType === 'student' ? <SignUpStudentPanel /> : <SignUpCarousel />}
        </div>
      </div>
    </>
  );
}
